import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Analytics } from "@vercel/analytics/react";
import Header from "./components/Header";
import Footer from "./components/Footer";
import FloatingBackToTop from "./components/FloatingBackToTop";
import Home from "./pages/Home";
import MutualFundsPage from "./pages/MutualFundsPage";
import FixedDepositsPage from "./pages/FixedDepositsPage";
import FinancialPlanningPage from "./pages/FinancialPlanningPage";
import InsurancePage from "./pages/InsurancePage";

// Add intersection observer for animations
const useIntersectionObserver = () => {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate');
          }
        });
      },
      { threshold: 0.1 }
    );

    const animatedElements = document.querySelectorAll('.fade-in-up, .scale-in');
    animatedElements.forEach((el) => observer.observe(el));

    return () => {
      animatedElements.forEach((el) => observer.unobserve(el));
    };
  }, []);
};

function App() {
  useIntersectionObserver();

  return (
    <div className="App">
      <BrowserRouter>
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services/mutual-funds" element={<MutualFundsPage />} />
          <Route path="/services/fixed-deposits" element={<FixedDepositsPage />} />
          <Route path="/services/financial-planning" element={<FinancialPlanningPage />} />
          <Route path="/services/insurance" element={<InsurancePage />} />
        </Routes>
        <Footer />
        <FloatingBackToTop />
      </BrowserRouter>
      <Analytics />
    </div>
  );
}

export default App;